<template>
  <svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6966 16.0637L11.8395 13.8538V18.2736L15.6966 16.0637ZM18.2681 16.9477C18.9538 16.5548 18.9538 15.5726 18.2681 15.1798L11.3252 11.202C10.6395 10.8091 9.78235 11.3002 9.78235 12.0859L9.78235 20.0415C9.78235 20.8272 10.6395 21.3183 11.3252 20.9254L18.2681 16.9477Z"
      fill="#A6192E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.19755 13.5192C1.71432 19.0942 5.02701 24.832 10.5966 26.335C16.1663 27.838 21.8838 24.5371 23.367 18.9621C24.8502 13.3872 21.5375 7.64938 15.9679 6.14636C14.575 5.77049 13.1755 5.69514 11.8358 5.87943L11.5504 3.84219C13.1569 3.62118 14.8333 3.71218 16.4961 4.1609C23.1613 5.95955 27.1255 12.8259 25.3506 19.4974C23.5756 26.1689 16.7335 30.1191 10.0684 28.3205C3.40328 26.5218 -0.560987 19.6554 1.21397 12.9839C2.07637 9.7425 4.1367 7.14204 6.7893 5.53338L7.85628 7.29338C5.63758 8.63891 3.9184 10.8098 3.19755 13.5192Z"
      fill="#A6192E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6821 0.185556C14.1457 0.449551 14.317 1.0568 14.0647 1.54189L12.3546 4.82979L14.7271 7.36398C15.0965 7.7585 15.0903 8.39162 14.7132 8.77809C14.3362 9.16456 13.7311 9.15803 13.3617 8.76351L10.0001 5.17282L12.3858 0.585885C12.6381 0.100795 13.2185 -0.0784384 13.6821 0.185556Z"
      fill="#A6192E"
    />
  </svg>
</template>
